<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="employeeDataApprove"
        class="border-table-employee text-no-wrap mt-1"
        item-key="no"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
        :loading="loading"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + employeeDataApprove.indexOf(item)+1 }}
      </template>
      <!-- ปิดไว้ก่อน -->
        <!-- <template v-slot:[`item.userImg`]="{ item }">
          <td style="width: fit-content !important;" class="py-2">
            <v-avatar
              size="44"
              rounded
            >
              <v-img
                :lazy-src="require('@/assets/icons/no_user.png')"
                :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                :alt="item.employeeId"
                v-on:error="onImgError(item.no-1)"
              />
            </v-avatar>
          </td>
        </template> -->
        <!-- end -->
        <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }">
          <v-row class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    dark
                    icon
                    tile
                    class="ml-10"
                    @click="editPage(item)">
                    <template v-slot>
                      <v-icon small dark class="icon-eye-color">mdi-pencil-outline</v-icon>
                    </template>
                  </v-btn>
                </template>
                <span class="label-table-action">จัดการพนักงาน</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    dark
                    icon
                    tile
                    class="ml-2"
                    @click="checkRemove(item)">
                    <template v-slot>
                      <v-icon small color="error">mdi-delete-outline</v-icon>
                    </template>
                  </v-btn>
                </template>
                <span class="label-table-action">ลบพนักงาน</span>
              </v-tooltip> -->
              <v-btn
                v-if="item.children.length !== 0"
                class=""
                text
                icon
                v-show="item.children"
                @click="expand(!isExpanded)"
              >
                <v-icon v-if="!isExpanded">mdi-chevron-down</v-icon>
                <v-icon v-else>mdi-chevron-up</v-icon>
              </v-btn>
          </v-row>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" style="background-color: #F5F5F5;" v-if="item.children.length !== 0">
              <div class="row" style="background-color: #F5F5F5; margin-left: -16px; margin-right: -16px;">
                <v-simple-table class="" style="width:100%; border-radius: 0px; background-color: #F5F5F5;">
                <template v-slot:default>
                  <thead>
                  </thead>
                  <tbody>
                    <tr v-for="(other, j) in item.children" :key="j">
                      <td style="width:70px;"></td>
                      <td style="width:75px;"></td>
                      <td style="width:212px;" align="left">{{ other.NameTh }}</td>
                      <td style="width:100px;" align="left">{{ other.employeeId }}</td>
                      <td style="width:200px;" align="left">{{ other.typeText }}</td>
                      <td style="width:180px;" align="left">{{ other.position }}</td>
                      <td style="width:200px;" align="left">{{ other.orgChartHeader || 'สายงานกรรมการบริหาร' }}</td>
                      <td style="width:100px;" align="left">{{ other.companyName }}</td>
                      <td style="width: 350px;"></td>
                      <!-- <td width=140 style="position: sticky !important;
                          position: -webkit-sticky !importa`nt;
                          right: 0;
                          z-index: 9997;
                          background: white;
                          -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
                          -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
                          box-shadow: -1px 0px 3px -1px rgba(0, 0, `0, 0.19);"
                          class="column-fix"
                          ></td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              </div>
          </td>
      </template>
    </v-data-table>
    <v-row>
        <v-col cols="12" class="pa-0">
        <div class="justify-end d-flex align-end pt-4">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="dialogDeleteEmployee" max-width="500px">
        <v-card height="170px">
          <v-card-title class="icon-eye-color ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
          <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn class="button-color-outline" outlined @click="dialogDeleteEmployee = false">ยกเลิก</v-btn>
            <v-btn class="button-color" dark @click="removeEmployeeResign(itemConfirmDelete)">ลบข้อมูล</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <DialogShowDetail/>
  </div>
</template>

<script>
import {
  // getSelectEmployeeApprove,
  getEmployeeListResign, // api count และข้อมูลในตาราง
  // getCompanyFilter, ปิด 21/04/66
  hostImageUrlv3,
  // getSelectEmployeeResign, //ทดลองเอาออก
  // getSelectEmployee, ปิด 21/04/66
  getPendingRequestApproveEmployee,
  deleteEmployeeResign
} from '@/API/API'
import DialogShowDetail from '../_dialog/dialogShowDetail'
import { OverlayLoading } from '@/components/index'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import moment from 'moment'

export default {
  components: {
    OverlayLoading, DialogShowDetail
  },
  data () {
    return {
      dialogDeleteEmployee: false,
      singleExpand: true,
      expanded: [],
      togglers: {},
      keywordReqNo: [],
      keywordCompanyName: [],
      itemConfirmDelete: [],
      keywordReqType: '',
      keywordUserName: '',
      keywordUserPosition: '',
      keywordOrgChartHeader: '',
      keywordGroupCompany: '',
      keywordStatus: '',
      tabResign: 'all',
      loading: true,
      tokenUser: '',
      countAllUser: 0,
      countPendingResign: 0,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '70px'
        },
        // { text: 'รูปภาพ', value: 'userImg', width: '75px' }, // ปิดไว้ก่อน
        { text: 'ชื่อ-นามสกุล', value: 'nameTh', width: '212px' },
        { text: 'รหัสพนักงาน', value: 'employeeId', width: '100px' },
        // { text: 'ประเภทพนักงาน', value: 'typeText', width: '200px' },
        { text: 'ตำแหน่ง', value: 'position', width: '180px' },
        // { text: 'แผนก', value: 'orgChartHeader', width: '200px' },
        { text: 'บริษัท', value: 'companyName', width: '100px' },
        { text: 'อีเมล', value: 'emailOneId', width: '100px', divider: true },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }
        // { text: '', value: 'data-table-expand' }
      ],
      mockup: [],
      selectData: [],
      employeeDataApprove: [],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('filterEmployeeResign', this.getSelect)
    EventBus.$on('filterPendingEmployeeResign', this.filterPendingEmployeeResign)
    EventBus.$on('downloadFileResign', this.downloadFile)
    EventBus.$on('closedialogUploadFile', this.initData)
  },
  beforeDestroy () {
    EventBus.$off('filterEmployeeResign')
    EventBus.$off('downloadFileResign')
    EventBus.$off('closedialogUploadFile')
  },
  methods: {
    onImgError (i) {
      this.employeeDataApprove[i].failed_image = true
    },
    checkRemove (item) {
      this.itemConfirmDelete = []
      this.itemConfirmDelete = item
      this.dialogDeleteEmployee = true
    },
    async removeEmployeeResign (item) {
      try {
        const res = await deleteEmployeeResign(item.userId, this.$store.state.token)
        if (res.success) {
          this.initData()
        } else {
          // swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          //   button: false,
          //   timer: 2000
          // })
        }
      } catch (error) {
        console.log(error)
        // swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
        //   button: false,
        //   timer: 2000
        // })
      }
      this.dialogDeleteEmployee = false
      // this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      // this.snackbar = true
    },
    getSelect (data) {
      this.keywordReqNo = data.employeeId
      this.keywordCompanyName = data.companyName
      this.keywordReqType = data.requestType
      this.keywordUserName = data.employeeName
      this.keywordOrgChartHeader = data.orgChartHeader
      this.keywordGroupCompany = data.groupCompany
      this.keywordUserPosition = data.position
      this.keywordStatus = data.requestStatus
      this.tabResign = data.tab
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTableResign(data)
    },
    filterPendingEmployeeResign (data) {
      this.keywordReqNo = data.employeeId
      this.keywordCompanyName = data.companyName
      this.keywordReqType = data.requestType
      this.keywordUserName = data.employeeName
      this.keywordOrgChartHeader = data.orgChartHeader
      this.keywordGroupCompany = data.groupCompany
      this.keywordUserPosition = data.position
      this.keywordStatus = data.requestStatus
      this.tabResign = data.tab
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getPendingEmployeeResign(data)
    },
    initData () {
      this.initSelectData()
      // this.initDataTableResign()
      // this.getCompanyFilterApprove() // ปิดเทส 21.04.66
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      this.userData = []
      // const token = this.tokenUser
      this.initDataTableResign(this.selectData)
      try {
        // const res = await getSelectEmployee(token)
        // if (res.success) {
        //   if (res.result) {
        //     this.selectData = res.result
        //   }
        // }
      } catch (error) {
        console.log(error)
      } finally {
        // this.loading = false
      }
    },
    // async getCompanyFilterApprove () {
    //   const token = this.tokenUser
    //   try {
    //     const res = await getCompanyFilter(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         this.selectData = res.result
    //       }
    //     } else {
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    changePerPage (value) {
      this.perPage = value
      if (this.tabResign === 'pending') {
        this.getPendingEmployeeResign()
      } else {
        this.initDataTableResign()
      }
    },
    changePage (value) {
      this.page = value
      if (this.tabResign === 'pending') {
        this.getPendingEmployeeResign()
      } else {
        this.initDataTableResign()
      }
    },
    async initDataTableResign (val) {
      const self = this
      self.loading = true
      self.employeeDataApprove = []
      const temp = []
      var obj = {
        employeeId: this.keywordReqNo,
        name: this.keywordUserName,
        company: this.keywordCompanyName,
        orgChartHeader: this.keywordOrgChartHeader,
        groupCompany: this.keywordGroupCompany,
        position: this.keywordUserPosition,
        tab: this.tabResign,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getEmployeeListResign(obj, this.tokenUser)
        if (res.result) {
          this.countPendingResign = res.countPendingResugn
          this.countAllUser = res.countAllUser
          self.total = res.countAllUser
          res.result.forEach((el, index) => {
            const userImgPath = el.userImg === undefined || el.userImg === '' ? `${hostImageUrlv3}/_/${el.emailOneId}` : `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
            temp.push({
              no: index + 1,
              ...el,
              userImg: userImgPath
            })
          })
          self.employeeDataApprove = temp
          EventBus.$emit('selectEmployeeResign', val, this.countAllUser)
        } else {
          // console.log('Res', res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getPendingEmployeeResign (val) {
      const self = this
      self.loading = true
      self.employeeDataApprove = []
      const temp = []
      var obj = {
        employeeId: this.keywordReqNo,
        name: this.keywordUserName,
        company: this.keywordCompanyName,
        orgChartHeader: this.keywordOrgChartHeader,
        groupCompany: this.keywordGroupCompany,
        position: this.keywordUserPosition,
        tab: this.tabResign,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getPendingRequestApproveEmployee(obj, this.tokenUser)
        if (res.result) {
          this.countPendingResign = res.countAllUser
          self.total = res.countAllUser
          res.result.forEach((el, index) => {
            const userImgPath = el.userImg ? `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}` : `${hostImageUrlv3}/_/${el.emailOneId}`
            temp.push({
              no: index + 1,
              ...el,
              userImg: userImgPath
            })
          })
          self.employeeDataApprove = temp
          EventBus.$emit('selectPendingEmployeeResign', this.countPendingResign)
        } else {
          // console.log('Res', res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async downloadFile () {
      this.loading = true
      let query = '?status=resign'
      if (this.keywordUserName.length > 0) {
        query += `&name=${this.keywordUserName}`
      }
      if (Array.isArray(this.keywordCompanyName) && this.keywordCompanyName.length > 0) {
        query += `&company=${this.keywordCompanyName.toString()}`
      }
      if (this.tabResign !== '' || this.tabResign !== null) {
        query += `&tab=${this.tabResign}`
      }

      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/users/download${query}`,
        headers: {
          authorization: this.tokenUser
        }
        // url: `${this.api}/uploads/companyFile/fileposition.xlsx`
      }).then((response) => {
        const date = moment().format('DD-MM-YYYY_HH-mm-ss_')
        FileSaver.saveAs(new Blob([response.data]), `${date}ไฟล์ข้อมูลพนักงานลาออก.xlsx`)
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    editPage (data) {
      // this.$router.push('/manageemployee/update')
      var tabValue = 'employeeResign/'
      this.$router.push('manageemployee/update/' + tabValue + data.userId)
      // this.$router.push({
      //   name: 'manageEmployeeUpdate',
      //   params: {
      //     item: data,
      //     id: data._id,
      //     tab: 'employeeResign'
      //   }
      // })
    },
    view (item) {
      EventBus.$emit('openDialogManageApprove', item)
    },
    manageLineWork (data) {
      // console.log('manage Employee', data)
    },
    gotocreate () {
      this.$router.push('manageemployee/create')
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
